import { render, staticRenderFns } from "./BaseMatrixTableColumn.vue?vue&type=template&id=c31ae722"
import script from "./BaseMatrixTableColumn.vue?vue&type=script&lang=js"
export * from "./BaseMatrixTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports